import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Dropdown, { dropdownable } from 'components/base/Dropdown';
import Button from 'components/base/Button';
import { SolidButton } from 'components/Button';
import Radio from 'components/base/Radio';
import { savePropertyGroupOptions, selectGroupContext } from 'data/property';
import { getOptionsWithDefault } from 'utils/normalizers/dropdown';
import { MAIN_CONTEXT } from 'reducers';

import css from './style.scss';
import Select from '../../../../components/Select';


const AddOptions = [
  { label: 'Ignore', value: '' },
  { label: 'Add to this list', value: 'AUTO' },
  { label: 'Add to another list', value: 'MOVE' },
  { label: 'I\'ll do it myself', value: 'MANUAL' },
];

const RemoveOptions = [
  { label: 'Ignore', value: '' },
  { label: 'Remove from this list', value: 'AUTO' },
  { label: 'Move to another list', value: 'MOVE' },
  { label: 'I\'ll do it myself', value: 'MANUAL' },
];

const NotificationIntervals = [
  { label: 'Never', value: '' },
  { label: 'Immediately', value: 'IMMEDIATE' },
  { label: 'Daily', value: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY' },
];

const getState = (props) => {
  const { id, addAction = '', addNotificationInterval = '', addGroupId = '', removeAction = '', removeNotificationInterval = '', removeGroupId = '' } = props.context.get('info').toJS();

  return { id, addAction, addNotificationInterval, addGroupId, removeAction, removeNotificationInterval, removeGroupId };
};

class PropertyGroupOptions extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleOutsideMouseDown = this.handleOutsideMouseDown.bind(this);
    this.updateDropdownPosition = this.updateDropdownPosition.bind(this);
    this.wrapperRef = React.createRef();
    this.state = { ...getState(props), dropdownStyle: {} };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideMouseDown);
    window.addEventListener('resize', this.updateDropdownPosition);
    window.addEventListener('scroll', this.updateDropdownPosition, true);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) this.updateDropdownPosition();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideMouseDown);
    window.removeEventListener('resize', this.updateDropdownPosition);
    window.removeEventListener('scroll', this.updateDropdownPosition, true);
  }
  // remove once decorate.js switches to mousedown globally.
  handleOutsideMouseDown(event) {
    const { isOpen, closeDropdown } = this.props;
    if (isOpen && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      closeDropdown();
    }
  }

  componentWillReceiveProps(props) {
    if (props.context.get('id') !== this.state.id || (props.isOpen && !this.props.isOpen)) this.setState(getState(props));
  }

  // The panel is wider than its trigger button and needs to escape the grid's local
  // stacking context (it otherwise renders behind the left sidebar), so it stays
  // `position: fixed` — anchored here to the trigger's actual on-screen position
  // instead of a hardcoded viewport offset.
  updateDropdownPosition() {
    if (!this.props.isOpen || !this.wrapperRef.current) return;
    const rect = this.wrapperRef.current.getBoundingClientRect();
    this.setState({
      dropdownStyle: {
        top: rect.bottom + 8,
        right: Math.max(window.innerWidth - rect.right, 0),
      },
    });
  }

  handleClick(i) {
    const { closeDropdown, onSelect } = this.props;
    closeDropdown();
    (i.onSelect || onSelect)(i);
  }

  handleSave() {
    const { savePropertyGroupOptions, closeDropdown } = this.props;
    const { id, addAction, addNotificationInterval, addGroupId, removeAction, removeNotificationInterval, removeGroupId } = this.state;

    savePropertyGroupOptions({
      id,
      addAction: addAction === '' ? null : addAction,
      addNotificationInterval: addNotificationInterval === '' || addAction === '' ? null : addNotificationInterval,
      addGroupId: addGroupId === '' || addAction === '' ? null : addGroupId,
      removeAction: removeAction === '' ? null : removeAction,
      removeNotificationInterval: removeNotificationInterval === '' || removeAction === '' ? null : removeNotificationInterval,
      removeGroupId: removeGroupId === '' || removeAction === '' ? null : removeGroupId,
    }, closeDropdown);
  }

  handleChange(ev) {
    const { name, value } = ev.target || ev;
    this.setState({ [name]: value });
  }

  render() {
    const { isOpen, onClick, closeDropdown, loading, lists, onRef, trigger } = this.props;
    const { addAction, addNotificationInterval, addGroupId, removeAction, removeNotificationInterval, removeGroupId, dropdownStyle } = this.state;
    const btnProps = { kind: Button.kind.grayGhost, className: css.btn, isLoading: loading };
    const ddProps = { onChange: this.handleChange };
    const { top, right } = dropdownStyle;

    return (
      <div className={classNames(css.options, { [css.open]: isOpen })} onClick={onClick} name="dropdown-btn" ref={this.wrapperRef}>
        {React.isValidElement(trigger) ? React.cloneElement(trigger, { active: isOpen }) : trigger}
        <div
          className={css.dropdown}
          ref={onRef}
          style={top === undefined ? undefined : { top: `${top}px`, right: `${right}px` }}
        >
          <div className={css.container}>
          <div className={css.header}>Automate List</div>
          <div className={css.section}>
            <div className={css.title}>New Properties</div>
            <div className={css.description}>When new properties that match your exact search criteria come available, do the following:</div>
            <div className={css.content}>
              <div className={css.item}>
                <Select
                  name="addAction"
                  lists={AddOptions}
                  selectedValue={addAction}
                  valueKey="value"
                  labelKey="label"
                  inputStyle={{color:'#808894'}}
                  onSelect={(item) =>
                    this.handleChange({
                      name: "addAction",
                      value: item.value,
                    })
                  }
                />
              </div>
              {addAction !== 'MOVE' ? null : (
                <div className={css.item}>
                  <div className={css.label}>Target List:</div>
                  <Select
                  name="addGroupId"
                  lists={getOptionsWithDefault(lists, 'Select List')}
                  selectedValue={addGroupId}
                  valueKey="value"
                  labelKey="label"
                  inputStyle={{color:'#808894'}}
                  onSelect={(item) =>
                      this.handleChange({
                        name: "addGroupId",
                        value: item.value,
                      })
                  }
                />
                </div>
              )}
            </div>
            {addAction === '' ? null : (
              <div className={css.subSection}>
                <div className={css.description}>Email me when new properties become available that match my search criteria for this list:</div>
                <div className={css.content}>
                  <div className={css.item}>
                    <div className={css.toggleGroup}>
                      {NotificationIntervals.map(({ value, label }) => (
                        <button
                          key={value}
                          type="button"
                          className={classNames(css.toggleBtn, {
                            [css.active]: addNotificationInterval === value
                          })}
                          onClick={() => this.handleChange({ target: { name: 'addNotificationInterval', value } })}
                          role="radio"
                          aria-checked={addNotificationInterval === value}
                          aria-label={`${label} notification`}
                        >
                          {label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={css.section}>
            <div className={css.title}>Property Changes</div>
            <div className={css.description}>When new properties change from your exact search criteria in this list, do the following:</div>
            <div className={css.content}>
              <div className={css.item}>
                 <Select
                  name="removeAction"
                  lists={RemoveOptions}
                  selectedValue={removeAction}
                  valueKey="value"
                  labelKey="label"
                  inputStyle={{color:'#808894'}}
                  onSelect={(item) =>
                    this.handleChange({
                      name: "removeAction",
                      value: item.value,
                    })
                  }
                />
              </div>
              {removeAction !== 'MOVE' ? null : (
                <div className={css.item}>
                  <div className={css.label}>Target List:</div>
                  <Select
                  name="removeGroupId"
                  lists={getOptionsWithDefault(lists, 'Select List')}
                  selectedValue={removeGroupId}
                  valueKey="value"
                  labelKey="label"
                  inputStyle={{color:'#808894'}}
                  onSelect={(item) =>
                    this.handleChange({
                      name: "removeGroupId",
                      value: item.value,
                    })
                  }
                  />
                </div>
              )}
            </div>
            {removeAction === '' ? null : (
              <div className={css.subSection}>
                <div className={css.description}>Notify me when properties no longer match this list:</div>
                <div className={css.content}>
                  <div className={css.item}>
                    <div className={css.toggleGroup}>
                      {NotificationIntervals.map(({ value, label }) => (
                        <button
                          key={value}
                          type="button"
                          className={classNames(css.toggleBtn, {
                            [css.active]: removeNotificationInterval === value
                          })}
                          onClick={() => this.handleChange({ target: { name: 'removeNotificationInterval', value } })}
                          role="radio"
                          aria-checked={removeNotificationInterval === value}
                          aria-label={`${label} notification`}
                        >
                          {label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={css.buttons}>
            <button {...btnProps} className={css.btnSecondary} onClick={closeDropdown}>Close</button>
            <button {...btnProps} className={css.btnPrimary} onClick={this.handleSave}>Save</button>
          </div>
          </div>
        </div>
      </div>
    );
  }
}

export default dropdownable(connect(state => ({
  context: selectGroupContext(MAIN_CONTEXT)(state),
}), {
  savePropertyGroupOptions,
})(PropertyGroupOptions));
